import localPreferencesServiceImpl from '../local-preferences-service';
import preferencesApiImpl from '../preferences-api';
import type { LocalPreferencesService, PreferencesApi } from './contracts';

export type {
  LocalPreferencesService,
  LocalPreferences,
  MNIDashboard,
  MNIDashboardWidgetPreferences,
  MyMNIPreferences,
  PreferencesApi,
} from './contracts';
export { HeadlineViewProvider, useGlobalHeadlineView } from '../headline-view-context';
export { defaultPreferences } from '../local-preferences-service';
export { MessageConnectionType } from '../message-connection-type';
export { PreferenceConstants } from '../preferences-api';
export {
  DEFAULT_TEXT_SCALE,
  MAX_TEXT_SCALE,
  MIN_TEXT_SCALE,
  TextScaleProvider,
  useGlobalTextScale,
} from '../text-scale-context';
export const localPreferencesService: LocalPreferencesService = localPreferencesServiceImpl;
export const preferencesApi: PreferencesApi = preferencesApiImpl;
